<div class="accordion" [class.expanded]="isExpanded">
    <button class="accordion-title-row" (click)="isExpanded = !isExpanded">
        <span class="accordion-title">{{ title }}</span>
        <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
    <p *ngIf="isExpanded" class="accordion-content" @slideInAndOutVertically>
        <ng-content></ng-content>
    </p>
</div>
